import { useParams } from "react-router-dom";
import { Box, Heading, Text, VStack, Icon } from "@chakra-ui/react";
import { CheckCircleIcon, WarningIcon } from "@chakra-ui/icons";


export const PaymentSuccessPage = () => {
  const { paymentId } = useParams();

  return (
    <Box
      minH="100vh"
      bg="gray.50"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={4}
    >
      <Box
        bg="white"
        p={8}
        rounded="2xl"
        shadow="lg"
        textAlign="center"
        maxW="lg"
        w="full"
      >
        <VStack spacing={4}>
          <Icon as={CheckCircleIcon} w={12} h={12} color="green.400" />
          <Heading as="h2" size="lg">
            Payment Successful
          </Heading>
          <Text fontSize="md" color="gray.600">
            Your payment with ID{" "}
            <Text as="span" fontWeight="bold" color="gray.800">
              {paymentId}
            </Text>{" "}
            has been processed successfully.
          </Text>
        </VStack>
      </Box>
    </Box>
  );
};


export const PaymentFailurePage = () => {
    const { paymentId } = useParams();
  
    return (
      <Box
        minH="100vh"
        bg="gray.50"
        display="flex"
        alignItems="center"
        justifyContent="center"
        px={4}
      >
        <Box
          bg="white"
          p={8}
          rounded="2xl"
          shadow="lg"
          textAlign="center"
          maxW="lg"
          w="full"
        >
          <VStack spacing={4}>
            <Icon as={WarningIcon} w={12} h={12} color="red.400" />
            <Heading as="h2" size="lg" color="red.500">
              Payment Failed
            </Heading>
            <Text fontSize="md" color="gray.600">
              Unfortunately, your payment with ID{" "}
              <Text as="span" fontWeight="bold" color="gray.800">
                {paymentId}
              </Text>{" "}
              was not successful.
            </Text>
            <Text fontSize="sm" color="gray.500">
              Please check your payment details or try again later.
            </Text>
          </VStack>
        </Box>
      </Box>
    );
  };